import * as React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import estetica from '../../../assets/manicure.jpg';
import tratamentos from '../../../assets/treatment.jpg';
import cabeleireiro from '../../../assets/hairTreatment.jpg';

// Define interface for service data
interface Service {
  id: number;
  title: string;
  image: string;
  redirectId: number;
}

const Services: React.FC = () => {
  const navigate = useNavigate();

  const servicesData: Service[] = [
    {
      id: 1,
      title: 'Estética',
      image: estetica,
      redirectId: 1,
    },
    {
      id: 2,
      title: 'Tratamentos',
      image: tratamentos,
      redirectId: 3,
    },
    {
      id: 3,
      title: 'Cabeleireiro',
      image: cabeleireiro,
      redirectId: 5,
    },
  ];

  // Function to handle card click and navigate
  const handleCardClick = (id: number) => {
    navigate('/servicos', { state: { serviceID: id } });
  };

  // Animation variants for the container (staggering children)
  const sectionVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.8,
      },
    },
  };
  // Animation variants for each service card
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.section
      id="servicos"
      className="pb-24 pt-20 bg-light text-center"
      initial="hidden"
      whileInView="visible" // Trigger animation when in view
      viewport={{ once: true}} // Trigger once
      variants={sectionVariants} // Apply container variants here for initial setup
    >
      <div className="container mx-auto px-4">
        <motion.h2
          className="text-4xl lg:text-5xl mb-12 lg:mb-16"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }} // Simple fade-in for title
          transition={{ duration: 0.6, delay: 0.9 }}
        >
          Serviços
        </motion.h2>
        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12"
          variants={sectionVariants} // Apply again for staggering effect
          initial="hidden"
          animate="visible" // Ensure this animate prop matches the parent's whileInView state
        >
          {servicesData.map((service) => (
            <motion.div
              key={service.id}
              className="bg-light rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col items-center cursor-pointer"
              variants={cardVariants}
              transition={{ duration: 0.5, ease: "easeOut" }}
              onClick={() => handleCardClick(service.redirectId)}
            >
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-72 object-cover"
              />
              <p className="my-6 min-w-[150px] text-xl">
                {service.title}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Services; 